import React from "react"
import * as S from "./Cards.styles"

export default () => {
    return (
        <S.Cards>
            <S.SingleCard videoSrc="https://youtu.be/lDFjQhzSqSg" name="Message from Head of Music"/>
            <S.SingleCard videoSrc="https://youtu.be/KeWA0AYYEVU" name="Nursery Medley - Teacher Ensemble"/>
            <S.SingleCard videoSrc="https://youtu.be/vYdrhSugRVM" name="Drums - Mr James"/>
            <S.SingleCard videoSrc="https://youtu.be/RD_IaXEx4gU" name="Flute, Clarinet & Saxophone - Miss Gemma"/>
            <S.SingleCard videoSrc="https://youtu.be/Y_YEKhxmjxg" name="Guitar - Mr Chris"/>
            <S.SingleCard videoSrc="https://youtu.be/cQoZMds6lzo" name="Piano - Miss Beverley"/>
            <S.SingleCard videoSrc="https://youtu.be/_bYqIztF5v8" name="Piano - Mr Olly"/>
            <S.SingleCard videoSrc="https://youtu.be/_MKNEsz4zlc?si=P5xqnqhb41JoqA7A" name="Singing - Miss Antoinette"/>
            <S.SingleCard videoSrc="https://youtu.be/fwnNHBan8ww?si=XIqKgqiUcGc3NRP5" name="Singing - Miss Phoebe"/>
            <S.SingleCard videoSrc="https://youtu.be/eqR94PIrNnY" name="Trumpet - Mr Paul"/>
            <S.SingleCard videoSrc="https://youtu.be/9pB-JESSnEI" name="Violin - Miss Diane"/>
            <S.SingleCard videoSrc="https://youtu.be/or8KYEOgbp8" name="Violin & Viola - Miss Joanne"/>
            <S.SingleCard videoSrc="https://youtu.be/mjs8bZuHH_Y" name="Harp - Miss Nicola"/>
        </S.Cards>
    )
}
